import type { Layout, QuestionSubType } from '@mentimeter/http-clients';
import { TitleSectionDataHandler } from '@mentimeter/question-modules-shared';
import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Visualization } from './Visualization';
import type { OpenEndedResponse } from './types';

const previewData: OpenEndedResponse[] = [
  {
    responseText: 'All responses to your question will be shown here',
    id: '0',
    voteCount: 0,
    participantDisplayName: null,
  },
  {
    responseText: 'Each response can be up to 200 characters long',
    id: '1',
    voteCount: 0,
    participantDisplayName: null,
  },
  {
    responseText: 'Turn on voting to let participants vote for their favorites',
    id: '2',
    voteCount: 0,
    participantDisplayName: null,
  },
];

interface EditorEmptyStateProps {
  layout: Layout | undefined;
  subType: QuestionSubType;
  ConditionalVisualizationWrapper: React.ComponentType<BoxT>;
}

export const EditorEmptyState = ({
  layout,
  subType,
  ConditionalVisualizationWrapper,
}: EditorEmptyStateProps) => {
  return (
    <Box width="100%" height="100%">
      <TitleSectionDataHandler showTextSizeDropdown={true} />
      <ConditionalVisualizationWrapper height="100%" flex="1 1 100%">
        <Visualization
          subType={subType}
          visualizationState="view-results"
          responses={previewData}
          layout={layout}
          style={{ opacity: 0.5 }}
        />
      </ConditionalVisualizationWrapper>
    </Box>
  );
};
